<template lang="pug">
.pdp-form.pdp-form--hide-buy-online(
  v-if="product"
  novalidate
)
  product-info(
    :product="product"
    :price="price"
    :comparePrice="comparePrice"
    :nutritional-disclaimer="nutritionalDisclaimer"
    :nutrition-facts-visible="nutritionFactsVisible"
    :variant-title="currentVariantTitle"
  )
  form.pdp-form__add-to-cart(
    @submit.prevent="addToCart"
    novalidate
  )
    option-select-buttons(
      v-if="hasVariants"
      :label="product.options[0]"
      :product="product"
      :data-value="selectedOption1"
      option="option1"
      v-model="selectedOption1"
    )
    option-select-buttons(
      v-if="product.options.length > 1"
      :label="product.options[1]"
      :product="product"
      :data-value="selectedOption2"
      option="option2"
      v-model="selectedOption2"
    )
    option-select-buttons(
      v-if="product.options.length > 2"
      :label="product.options[2]"
      :product="product"
      :data-value="selectedOption3"
      option="option3"
      v-model="selectedOption3"
    )
  //-   template
  //-     .pdp-form__subscriptions
  //-       product-form-selling-plans(
  //-         v-if="product.selling_plan_groups.length"
  //-         :product="product"
  //-       )
  //-     .pdp-form__quantity-selector
  //-       label(for="quantity") Quantity
  //-       quantity-input.pdp-form__quantity(:quantity.sync="quantity" :max="availableQuantity" v-if="!isOutStock")
  //-       v-button.pdp-form__submit-btn(
  //-         :disabled="isOutStock"
  //-         :label="isOutStock ? 'Out of Stock' : 'Add To Cart'"
  //-         primary
  //-       )
  //- .pdp-shipping-text.body--sm(v-text="shippingText" v-if="enableBuyOnline")
</template>

<script>
  import { mapState } from 'vuex';

  import Icon from 'scripts/components/basic/Icon.vue';
  import VButton from 'scripts/components/buttons/VButton.vue';
  import OptionSelectButtons from 'scripts/components/forms/OptionSelectButtons.vue';
  import QuantityInput from 'scripts/components/forms/QuantityInput.vue';
  import ProductFormSellingPlans from 'scripts/components/product/ProductFormSellingPlans.vue';
  import ProductInfo from 'scripts/components/product/ProductInfo.vue';
  import { money } from 'scripts/filters/money.js';

  export default {
    name: 'ProductForm',
    components: {
      OptionSelectButtons,
      QuantityInput,
      ProductInfo,
      ProductFormSellingPlans,
      VButton,
      Icon
    },
    props: {
      product: Object,
      shippingText: String,
      nutritionalDisclaimer: String,
      nutritionFactsVisible: Boolean
    },
    data() {
      return {
        quantity: 1,
        availableQuantity: 0,
        activeVariant: null,
        enableBuyInStore: true,
        enableBuyOnline: true,
        selectedVariant: '',
        selectedOption1: '',
        selectedOption2: '',
        selectedOption3: ''
      };
    },
    watch: {
      currentVariant(newVariant) {
        this.$emit('variantChange', newVariant);
      }
    },
    computed: {
      ...mapState({
        variantParam: state => state.params.variant,
        purchaseType: ({ productPage }) => productPage.purchaseType,
        sellingPlan: ({ productPage }) => productPage.sellingPlan,
      }),
      hasVariants() {
        return this.product.variants_count > 1
      },
      hasComplexVariants() {
        return this.product ? this.product.options.length > 1 : false;
      },
      isOutStock() {
        if (this.hasVariant) {
          return !this.product.variants.some((variant) => variant.inventory_quantity)
        }
        return !this.product.available
      },
      currentVariant() {
        let currentVariant = this.product.variants[0];

        if (this.hasComplexVariants) {
          if (this.product.options.length > 2) {
            currentVariant = this.product.variants.find((variant) => variant.option1 === this.selectedOption1 && variant.option2 === this.selectedOption2 && variant.option3 === this.selectedOption3);
          } else {
            currentVariant = this.product.variants.find((variant) => variant.option1 === this.selectedOption1 && variant.option2 === this.selectedOption2);
          }
        } else if (this.hasVariants) {
          currentVariant = this.product.variants.find((variant) => variant.option1 === this.selectedOption1);
        }

        currentVariant = currentVariant || this.product.variants[0]; // Make sure we never return undefined

        this.enableBuyInStore = currentVariant.enable_buy_in_store;
        this.enableBuyOnline = currentVariant.enable_buy_online;
        this.availableQuantity = currentVariant.inventory_quantity;

        return currentVariant
      },
      currentVariantTitle() {
        return this.currentVariant ? this.currentVariant.title : '';
      },
      price() {
        return this.currentVariant ? money(this.currentVariant.price) : money(this.product.price);
      },
      comparePrice() {
        return this.currentVariant && this.currentVariant.compare_at_price > this.currentVariant.price
          ? money(this.currentVariant.compare_at_price)
          : null
      },
      productVariants() {
        if (this.hasVariants) {
          return this.product.variants
        }
      },
      productOptions() {
        return this.productVariants.map((variant) => {
          return {
            'option1': variant.option1,
            'option2': variant.option2,
            'option3': variant.option3
          }
        })
      }
    },
    methods: {
      publishToKlaviyo(product) {
        const item = {
          Name: product.title,
          ProductID: product.id,
          Categories: product.collections,
          ImageURL: product.featured_image,
          URL: product.url,
          Brand: product.vendor,
          Price: product.price,
          CompareAtPrice: product.compare_at_price,
        };
        if (window._learnq) {
          window._learnq.push(['track', 'Added to Cart', item]);
        }
      },
      /*setVariantOptions(variant_id) {
        console.log(variant_id, variant)
        this.availableQuantity = variant[0].inventory_quantity;
        this.activeVariant = variant[0].id;
      },*/
      setDefaultPurchaseType() {
        const purchaseTypeDefault = this.$shop.subscriptions.select_subscription_first === 'true' ? 'autodeliver' : 'onetime';
        this.$store.dispatch('productPage/setPurchaseType', purchaseTypeDefault);
      },
      /*getNonVariantProducts() {
        console.log(this.product.variants)
        this.availableQuantity = this.product.variants[0].inventory_quantity
        this.activeVariant = this.product.variants[0].id
      },*/
      selectDefaultBarProduct() {
        // Select 4ct bar product if it exists
        if (this.productVariants) {
          const id = new URLSearchParams(window.location.search.substring(1)).get('id');
          if (id) {
            for (const v of this.productVariants) {
              if (v.id == id) {
                this.selectedOption1 = v.option1;
                this.selectedOption2 = v.option2;
                this.selectedOption3 = v.option3;
                return;
              }
            }
          }

          for (const [key, value] of Object.entries(this.productOptions)) {
            if (value.option1 && value.option1.toLowerCase() === '4 pack') {
              this.selectedOption1 = value.option1;
            }

            if (value.option2 && value.option2.toLowerCase() === '4 pack') {
              this.selectedOption2 = value.option2;
            }

            if (value.option3 && value.option3.toLowerCase() === '4 pack') {
              this.selectedOption3 = value.option3;
            }
          }
        }
      },
      addToCart() {
        const id = this.currentVariant.id;
        const addProducts = {
          id: id,
          quantity: this.quantity,
        };

        if (this.purchaseType === 'autodeliver') {
          addProducts.selling_plan = this.sellingPlan.id
        }

        this.publishToKlaviyo(this.product);
        this.$store
          .dispatch('cart/addItem', addProducts)
          .then(() => this.$store.dispatch('products/addProduct', this.product.handle))
          .then(() => this.$store.dispatch('cart/openSidecart'))
          .catch((error) => this.$store.dispatch('toast/send', { text: error, type: 'error' }))

        this.triggerAddToCartEvent(this.currentVariant);
      },
      triggerAddToCartEvent(variant) {
        window.getCustomerGuid((customer_guid) => {
          let addItemPayload = {
            'event': 'bva_add_to_cart',
            'user_id': customer_guid,
            'event_id': new Date().getTime() + '.' + Math.random().toString(36).substring(5),
            'ecommerce': {
              'currencyCode': window.BVA.shop.currencyCode,
              'add': {
                'actionField': {'list': 'product'},
                'products': [{
                  'id': variant.barcode,
                  'sku': variant.sku,
                  'handle': this.product.handle,
                  'productId': this.product.id,
                  'variantId': variant.id,
                  'name' : this.product.title.replace("'", ""),
                  'price': (variant.price / 100),
                  'brand' : this.product.vendor.replace("'", ""),
                  'variant': variant.title.replace("'", ""),
                  'category': this.product.type.replace("'",""),
                }]
              },
              'items': [
                {
                  item_id: variant.barcode,
                  gmi_product_id: variant.gmi_product_id,
                  shopify_product_id: this.product.id,
                  shopify_variant_id: variant.id,
                  shopify_sku: variant.sku.replace("'", ""),
                  shopify_handle: this.product.handle,
                  shopify_compare_price: (variant.compare_at_price || variant.price) / 100,
                  item_name : this.product.title.replace("'", ""),
                  affiliation: window.BVA.shop.name,
                  currency: window.BVA.shop.currencyCode,
                  item_brand : this.product.vendor.replace("'", ""),
                  item_category: variant.gmi_product_id,
                  item_list_id: 'product',
                  item_list_name: 'product',
                  item_variant: variant.title.replace("'",""),
                  price: (variant.price / 100),
                }
              ]
            }
          }

          Object.keys(this.product.options_with_values).forEach((key) => {
            addItemPayload.ecommerce.items[0][key] = this.product.options_with_values[key]
          });

          window.dataLayer = window.dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push(addItemPayload);
          console.log('event: add-item-event', addItemPayload);
        });
      }
    },
    created() {
      this.setDefaultPurchaseType();
    },
    mounted() {
      this.selectDefaultBarProduct();
    }
  };
</script>

<style scoped lang="scss">

.pdp-form--hide-buy-online {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom-width: 0;
}

.pdp-form__quantity-selector {
  display: flex;
  flex-wrap: wrap;
}
.pdp-form__quantity-selector > label {
  display: block;
  width: 100%;
}
.pdp-form__quantity {
  margin-right: 16px;
}

.pdp-form__submit-btn {
  flex: 1;
  text-align: left;
}

// Swatch
.pdp-form__swatches {
  display: flex;
  padding: 0 0 30px 0;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.pdp-form__swatch-name {
  margin: 0;
  font-size: rem(13px);
  text-transform: uppercase;
  font-weight: $font-weight-bold;
  letter-spacing: 2px;
  width: 100%;
  margin-bottom: rem(16px);

  @include tablet-up() {
   margin-bottom: $spacing-unit;
  }
}
.pdp-form__swatch {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  border: 1px solid $color-white;

  .icon { color: $color-white; }
  .icon,
  &:after {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:after {
    content: "";
    width: 38px;
  height: 38px;
    border-radius: 50%;
  }
  &:hover,
  &:active,
  &.active {
    &:after { border: 1px solid $color-white; }
  }
  &:not(:last-child) {
    margin-right: $spacing-unit;
  }
}
.pdp-form__shipping-link,
.pdp-form__shipping-link:link,
.pdp-form__shipping-link:visited {
  margin-top: rem(16px);
  color: $color-white;
  font-size: rem(13px);
  text-decoration: underline;
  display: block;
  font-family: $secondary-font-family;

  &:hover,
  &:active {
      text-decoration: none;
  }
}
</style>
